export default __webpack_public_path__ + "static/media/ahsoka_003.942453d1.jpeg";